import * as core from '../../../../../../../core'

import { query } from './stakeholders-table.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholders.table',
    description:
      'Table view of stakeholders filtered by degree of impact and influence',
    name: 'Stakeholders Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
